<template>
  <div>
    <div class="tab">
      <ul>
        <li class="clearfix" v-for="(item, index) in tabList" :key="index" @click="selectTab(item,index)"
          :class="item.tabName==$route.name?'active':''" v-if="item.id!=10||(item.id==10&&isOffcialVolunteer)">
          <div class="icon">
            <i :class="[item.iconClass]"></i>
            <!-- <img :src='item.img' alt /> -->
          </div>
          <p class="tab_text">
            {{item.name}}
            <span>
              <img src="../assets/images/tab_dy.png" alt />
            </span>
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>


<script>
  export default {
    props: {
      isOffcialVolunteer: {
        type: Boolean,
        required: false
      }
    },
    data() {
      return {
        current: 0,
        tabList: [{
            id: 1,
            name: "我报名的活动",
            tabName: "personalCenterActivity",
            iconClass: "icon-01"
          },
          {
            id: 2,
            name: "我的公益历程",
            tabName: "publicWelfare",
            iconClass: "icon-02"
          },
          {
            id: 3,
            name: "个人排名",
            tabName: "personalRanking",
            iconClass: "icon-03"
          },
          {
            id: 4,
            name: "我的积分记录",
            tabName: "integralRecord",
            iconClass: "icon-04"
          },
          //   {
          //     id: 5,
          //     name: "下载证明",
          //     tabName: "downloadProof",
          //     iconClass: "icon-05"
          //   },
          //  {
          //    id: 6,
          //    name: "我的建议",
          //    tabName: "mySuggest",
          //    iconClass: "icon-06"
          //  },
          {
            id: 7,
            name: "我要晒图",
            tabName: "sharingInsights",
            iconClass: "icon-07"
          },
          {
            id: 8,
            name: "我的团体",
            tabName: "myGroup",
            iconClass: "icon-08"
          },
          {
            id: 9,
            name: "我的收藏",
            tabName: "myCollection",
            iconClass: "icon-09"
          },
          {
            id: 10,
            name: "发起活动",
            tabName: "publishActivity",
            iconClass: "icon-05"
          }
        ]
      };
    },
    methods: {
      selectTab(item, index) {
        this.current = index;
        console.log("1111", item, index);
        if (item.id == 10) {
          window.open(this.opURL + "/#/activity/activityManage/create");
        } else {
          this.$router.push({
            name: item.tabName
          });
        }

        //   this.$emit('menuId', item.tabName)
      }
    }
  };

</script>

<style lang="scss" scoped>
  .tab {
    ul {
      .active {
        background: #ffffff;
      }

      li {
        width: 290px;
        height: 82px;
        line-height: 82px;
        background: #f7f7f7;
        text-align: center;
        line-height: 82px;

        &:last-of-type {
          p {
            border-bottom: none;
          }
        }

        &:hover {
          background: #ffffff;
        }

        .icon {
          width: 85px;
          height: 81px;
          float: left;

          i {
            display: inline-block;
            width: 35px;
            height: 30px;
            background-image: url("../assets/images/mine-icons.png");
            background-size: 420px 30px;
            vertical-align: middle;

            &.icon-01 {
              background-position: -35px * 3 0;
            }

            &.icon-02 {
              background-position: -35px * 4 0;
            }

            &.icon-03 {
              background-position: -35px * 5 0;
            }

            &.icon-04 {
              background-position: -35px * 6 0;
            }

            &.icon-05 {
              background-position: -35px * 7 0;
            }

            &.icon-06 {
              background-position: -35px * 8 0;
            }

            &.icon-07 {
              background-position: -35px * 9 0;
            }

            &.icon-08 {
              background-position: -35px * 10 0;
            }

            &.icon-09 {
              background-position: -35px * 11 0;
            }
          }
        }

        p {
          text-align: left;
          width: 205px;
          height: 81px;
          float: left;
          border-bottom: 1px solid #cccccc;
          position: relative;
        }

        span {
          position: absolute;
          top: 0;
          right: 12px;
          display: block;
          float: right;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/LayoutTab.vue